export function formatContentStatus(status: string) {
  switch (status) {
    case 'DRAFT': return 'Rascunho'
    case 'PUBLISHED': return 'Publicado'
    case 'REJECTED': return 'Rejeitado'
    default: return 'Rascunho'
  }
}